var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddR({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3335 12.6663C1.3335 13.7709 2.22893 14.6663 3.3335 14.6663H12.6668C13.7714 14.6663 14.6668 13.7709 14.6668 12.6663V3.33301C14.6668 2.22844 13.7714 1.33301 12.6668 1.33301H3.3335C2.22893 1.33301 1.3335 2.22844 1.3335 3.33301V12.6663ZM3.3335 13.333C2.96531 13.333 2.66683 13.0345 2.66683 12.6663V3.33301C2.66683 2.96482 2.96531 2.66634 3.3335 2.66634H12.6668C13.035 2.66634 13.3335 2.96482 13.3335 3.33301V12.6663C13.3335 13.0345 13.035 13.333 12.6668 13.333H3.3335ZM8.66683 4.66634C8.66683 4.29815 8.36836 3.99967 8.00016 3.99967C7.63196 3.99967 7.3335 4.29815 7.3335 4.66634V7.33301H4.66683C4.29864 7.33301 4.00016 7.63147 4.00016 7.99967C4.00016 8.36787 4.29864 8.66634 4.66683 8.66634H7.3335V11.333C7.3335 11.7012 7.63196 11.9997 8.00016 11.9997C8.36836 11.9997 8.66683 11.7012 8.66683 11.333V8.66634H11.3335C11.7017 8.66634 12.0002 8.36787 12.0002 7.99967C12.0002 7.63147 11.7017 7.33301 11.3335 7.33301H8.66683V4.66634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddR);
export default __webpack_public_path__ + "static/media/add-r.907a6fbec7302106a6775273b64338ac.svg";
export { ForwardRef as ReactComponent };